import {ListTable} from "../component/ListTable";
import {useContext, useEffect, useState} from "react";
import {Get} from "component/const/Get";
import {getUserId} from "component/const/ForAuth";
import {filter} from "component/const/Functions";
import {Context} from "../component/context";

export const Test = () =>{
    const {search} = useContext(Context);
    const [test, setTest] = useState(null)
    const [data, setData] = useState(null)
    useEffect(()=>{
        getUserId()
            .then(data=>{Get(`list_test_app?user_id=eq.${data}&posed=eq.true`)
                .then(res=>setTest(res))})
    },[])

    useEffect(() => {
        setData(filter(test, search))
    }, [test, search]);

    return <ListTable data={data}/>
}
